import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../config";
import { API_ELSTIC_URL } from "../../config";

export const fetchStates = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/states`);
    if (response.status === 200) {
      return response.data.map((state) => ({
        value: String(state.state_id),
        label: state.state_name,
      }));
    }
    return [];
  } catch (error) {
    console.error(error);
    toast.error("Error fetching states.");
    return [];
  }
};

// export const fetchBanks = async () => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/bank-master-list`);

//     console.log("Full API response:", response.data);

//     if (response.data.status === true) {
//       return response.data.data.map((bank) => ({
//         value: bank.id,
//         label: bank.bank_name,
//       }));
//     }

//     return [];
//   } catch (error) {
//     console.error("Bank fetch error:", error);
//     return [];
//   }
// };


export const fetchBanks = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/subscription/bank-master-list`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` } }
    );

    // console.log("HTTP Status:", response.status);
    // console.log("API Status:", response.data.status);
    // console.log("Bank Data:", response.data.data);

    if (response.status === 200 && response.data?.status === true) {
      return response.data.data.map((bank) => ({
        value: String(bank.id),  
        label: bank.bank_name,
      }));
    }

    return [];
  } catch (error) {
    console.error("Bank fetch error:", error);
    return [];
  }
};


export const loadCustomers = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-users-name`,
      {headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` }}
    );
    if (response.status === 200) {
      const customers = response.data.users || [];
      return customers;
    }

    // console.log("customers from service", response);

    return [];
  } catch (error) {
    console.error("Error loading customers:", error);
    toast.error("Failed to load customers.");
    return [];
  }
};

export const loadPlans = async () => {
  try {
    const plan_data = await axios.get(`${API_BASE_URL}/get-subscrpton-plan`);
    const pricing_plan = JSON.parse(JSON.stringify(plan_data.data));
    if (pricing_plan.status === 200) {
      return plan_data.data.data;
    }
    return [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const addCustomer = async (customerData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/add-customer`,
      customerData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createOrder = async (orderData, token) => {
  // console.log("Order data being sent to API:", orderData);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/subscription/create-order-v2`,
      orderData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPlansByAttorneyType = async (isAttorney) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-all-plans?is_for_attorney=${isAttorney}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAttorneyTMCounts = async (attorney_number) => {
  try {
    const attorneyQuery = attorney_number.join(',');
    const response = await axios.get(
      `${API_ELSTIC_URL}/attorney/get-attorney-trademark-count-by-code`,
      {
        params: {
          attorney_number: attorneyQuery,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSingleOrderDetails = async (order_id, user_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/subscription/get-order-details`,
      {
        params: {
          order_id: order_id,
          user_id: user_id
        },
        headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
      }
    );
    return response.data;
    
  } catch (error) {
    throw error;
  }
}

export const fetchPaymentModes = async () => {
  const res = await axios.get(`${API_BASE_URL}/get-payment-modes`,
    {headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` }
  }
  );
  return res.data;
};



export const approvePayment = async ({ orderId }) => {
  const response = await axios.post(
    `${API_BASE_URL}/subscription/approve-payment`,
    { order_id: orderId },
    { headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` } },
  );
  return response.data;
};

export const rejectPayment = async ({ orderId, rejectionReason }) => {
  const response = await axios.post(
    `${API_BASE_URL}/subscription/reject-payment`,
    { order_id: orderId, rejection_reason: rejectionReason },
    { headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` } },
  );
  return response.data;
};

export const deleteOrder = async (payload) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/subscription/delete-order`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}